import React, { useState, Fragment } from "react";
import { GET_WATCH_PROPERTIES } from "../../graphql/queries";
import {
  WATCH_PROPERTY_DELETE_MUTATION,
  PROPERTY_UPDATE_MUTATION,
} from "../../graphql/mutations";
import WatchProperties from ".";
import { Grid, Form } from "tabler-react";
import { useQuery, useMutation } from "@apollo/react-hooks";

const WatchPropertiesQueries = () => {
  const [filterDataState, setFilterDataState] = useState("");
  const [pageNumberState, setPageNumberState] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterHexUsers, setFilterHexUsers] = useState(true);
  const [pricingPack, setPricingPack] = useState("");
  const [active, setActive] = useState<boolean | undefined>();
  const [orderBy, setOrderBy] = useState("");
  const [orderByASC, setOrderByASC] = useState(false);
  const [shouldBeDeleted, setShouldBeDeleted] = useState(false);
  const [countryCodeState, setCountryCodeState] = useState("");
  const [sharedState, setSharedState] = useState<boolean | undefined>();
  const [withoutPromo, setWithoutPromo] = useState<boolean>(false);
  const [tool, setTool] = useState("");

  const { data, loading, refetch } = useQuery(GET_WATCH_PROPERTIES, {
    variables: {
      input: {
        regFrom: fromDate,
        regTo: toDate,
        pageNumber: pageNumberState,
        searchQuery: filterDataState,
        hideHex: filterHexUsers,
      },
      pricingPackage: pricingPack,
      active,
      orderBy,
      orderByASC,
      scheduledToDelete: shouldBeDeleted,
      csvDownload: false,
      countryCode: countryCodeState,
      tool,
      // shared: sharedState,
      // withoutPromo,
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });
  const [updateProperty] = useMutation(PROPERTY_UPDATE_MUTATION, {
    refetchQueries: [{ query: GET_WATCH_PROPERTIES }],
  });
  const [deleteProperty] = useMutation(WATCH_PROPERTY_DELETE_MUTATION, {
    refetchQueries: [{ query: GET_WATCH_PROPERTIES }],
  });

  const handleFilterDataChange = (filterData: string) =>
    setFilterDataState(filterData);
  const handlePageNumberChange = (pageNumber: number) =>
    setPageNumberState(pageNumber);
  const handleFromDate = (date: string) => setFromDate(date);
  const handleToDate = (date: string) => setToDate(date);
  const handlePackageSelect = (pack: string) => setPricingPack(pack);
  const handlePropertyStatus = (active: boolean | undefined) =>
    setActive(active);
  const handleScheduledToDelete = (deleted: boolean) =>
    setShouldBeDeleted(deleted);
  const handleCountryCode = (code: string) => setCountryCodeState(code);
  const handleSelectShared = (shared: boolean | undefined) =>
    setSharedState(shared);
  const handleSelectTool = (tool: string) => setTool(tool);

  return (
    <Fragment>
      <Grid.Row>
        <Grid.Col md={12}>
          <Form.Checkbox
            label="Filter Properties from Hexact"
            name="example-radios"
            value="option1"
            checked={filterHexUsers}
            onChange={() => setFilterHexUsers(!filterHexUsers)}
          />
        </Grid.Col>
      </Grid.Row>
      <WatchProperties
        data={data}
        loading={loading}
        onFilterDataChange={handleFilterDataChange}
        onPageNumberChange={handlePageNumberChange}
        onPackageSelect={handlePackageSelect}
        onPropertyIsActive={handlePropertyStatus}
        onShceduledToDelete={handleScheduledToDelete}
        onFromDate={handleFromDate}
        onToDate={handleToDate}
        onCountryCode={handleCountryCode}
        onSelectShared={handleSelectShared}
        onSelectTool={handleSelectTool}
        // onWithoutPromo={handleWithoutPromo}
        deleteProperty={deleteProperty}
        updateProperty={updateProperty}
        // rescanProperty={rescanProperty}
        refetchData={() => refetch()}
        filterHexProperties={filterHexUsers}
        setOrderByASC={setOrderByASC}
        orderByASC={orderByASC}
        setOrderBy={setOrderBy}
        variables={{
          input: {
            regFrom: fromDate,
            regTo: toDate,
            pageNumber: pageNumberState,
            searchQuery: filterDataState,
            hideHex: filterHexUsers,
          },
          pricingPackage: pricingPack,
          active,
          scheduledToDelete: shouldBeDeleted,
          countryCode: countryCodeState,
          // shared: sharedState,
          // withoutPromo,
          tool,
        }}
      />
    </Fragment>
  );
};

export default WatchPropertiesQueries;
